import * as yup from 'yup';
import { StringSchema } from 'yup';

function customId(this: StringSchema) {
  const format = {
    message: { key: 'string.matches.customId.format' },
  };

  return this.required().matches(/^[A-Z]{4}$/, format);
}

yup.addMethod(yup.string, 'customId', customId);
